// extracted by mini-css-extract-plugin
module.exports = {"root":"AttachmentsList_root__2QqH7","attachment":"AttachmentsList_attachment__29T-w","leftBlock":"AttachmentsList_leftBlock__2f4LT"};